//Componentes generales
import { useEffect, useState, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';

// Alertas
import Swal from 'sweetalert2'

//Estilos
import './FormNivel2.css';
import { PRINCIPAL, NAVBARS, COLOR_BTN, COLOR_BOTONES } from '../../constants/colors';

//Contextos
import nivel2Context from '../../context/nivel2Context/nivel2Context';
import activoContext from '../../context/activoContex/activoContex';
import { estructuraNivel1 } from '../../utils/estructuras';
import DictionaryText from '../dictionaryText/DictionaryText';
import authContext from '../../context/authentication/authContex';
import clienteAxios from '../../config/axios';

/*
    Componente encargado de mostrar el formulario de usuario.
        Donde data es el usuario crear/modificar.
              minimizar es la función encargada de ocultar el dialogo.
              generar es la función del context que guarda el usuario.
              titulo es la que determina que texto mostrar en encabezado del dialogo.
              verficaUser es la función del context que comprueba la licencia por usuario vigente del cliente.
*/
function FormNivel2({ data,setData, minimizar, formDato, nuevoEditado, i, handleChangeUbicaciones, generar = () => console.log("Generando"), listaUsuarios = [], optionsNivel1, nivel1Lista, areaSeleccionada, modo }) {
    
    // context agregarActivo - modificarrActivo
    const {actualizaractivoList} = useContext(activoContext)

    const pContext = useContext(nivel2Context);
    const {agregarNivel2, actualizarNivel2List, modificarNivel2, eliminarNivel2} = pContext;

    //State de usuario. Si no viene data por parametro significa que es nuevo por lo que se le asigna una estructura.
    const [nivel2, setNivel2] = useState((data !== undefined && nuevoEditado == 'Modificar') ? {group: {codNivel2:data?.codNivel2, name: data?.name, descrp:data?.descrp, codNivel1: areaSeleccionada?.codNivel1, id: data?.id, direccion: data?.direccion || '', lat: data?.lat || null, lng: data?.lng || null}} : {group: {codNivel2:"", name:"", descrp:"",codNivel1: areaSeleccionada.codNivel1, direccion: '', lat: null, lng: null}, members: []});
    const [opcionSeleccionada, setOpcionSeleccionada] = useState(null);

    const {getValorActualFromDictionary} = useContext(authContext);

    //areaSeleccionada tengo que agregarle el value y el label para que se vean.
    const areaSeleccionadaNormalizada = {
        value: areaSeleccionada?.name || areaSeleccionada?.label,
        label: areaSeleccionada?.name || areaSeleccionada?.label,
        // Resto de las propiedades que quieras copiar
        codNivel1: areaSeleccionada?.codNivel1,
        descrp: areaSeleccionada?.descrp,
        id: areaSeleccionada?.id,
        
    };

    const areaSeleccionadaValue = areaSeleccionada?.value !== undefined ? 
                  {...areaSeleccionada, value: areaSeleccionada.name, label: areaSeleccionada.name } 
                  : areaSeleccionada

    //Constante que define el titulo que corresponde si vienen datos por parametros
    const [titulo, setTitulo] = useState(nuevoEditado)
   
    //Funcion de validacion
    const validacion =  () => { 
        const newErrors = {};

        if (nivel2.group.codNivel2 === '' || nivel2.group.codNivel2 === undefined) return newErrors.codigo = 'El código debe ser colocado';
        if (nivel2.group.name === '' || nivel2.group.codNivel2 === undefined) return newErrors.nombre = 'El nombre debe ser colocado';
        if (nivel2.group.descrp === '' || nivel2.group.descrp === undefined) return newErrors.nombre = 'La descripción debe ser colocada';

        return '';    
    };

    const handleGeocodificar = async () => {
        try {
            const resp = await clienteAxios.get(`/geocode?address=${encodeURIComponent(nivel2.group.direccion)}`);
            const { lat, lng } = resp.data.data;
            setNivel2({ ...nivel2, group: { ...nivel2.group, lat, lng } });
        } catch (err) {
            Swal.fire({ icon: 'warning', title: 'No se pudo geocodificar',
                text: err.response?.data?.message || 'Verifique la direccion ingresada' });
        }
    };

    // manda los datos al back
    const handlerGenerar = async () => {

        const errorAxi = validacion();

        if (errorAxi === "" ) {

            try {

                const { group } = nivel2;

                // Crea un nuevo objeto sin la propiedad id
                const { id, ...datoSinId } = group;
                //compara el name del Select con el name de la la DB para mandar info a la DB
                const filtro = nivel1Lista?.filter(dato => dato?._id === areaSeleccionadaValue?.id);
                const nivel2Nivel1 = filtro[0]

                const datos = {...datoSinId, nivel2Nivel1}

                const res = await agregarNivel2(datos)
                
                if (res !== null) {
                    Swal.fire({
                        title: `Guardado exitosamente!`,
                        icon: 'success',
                        text: `Código: ${res.lv2Saved.codNivel2} \n Nombre: ${res.lv2Saved.name} `,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizaractivoList();
                    actualizarNivel2List();
                    minimizar();
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
            Swal.fire({
                title: errorAxi,
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }
    }

    const handlerModificar = async () => {
        const errorAxi = validacion();

        if (errorAxi === "") {
    
            try {
                const dato = {
                    id: nivel2.group.id === undefined ? data._id : nivel2.group.id,
                    codNivel2: nivel2.group.codNivel2,
                    codNivel1:nivel2.group.codNivel1,
                    name: nivel2.group.name,
                    descrp: nivel2.group.descrp,
                    direccion: nivel2.group.direccion,
                    lat: nivel2.group.lat,
                    lng: nivel2.group.lng
                }

                const res = await modificarNivel2(dato);

                if (res !== null) {
                    Swal.fire({
                        title: `Modificado exitosamente!`,
                        icon: 'success',
                        text: `Código: ${res.codNivel2} \n Nombre: ${res.name} `,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarNivel2List();
                    actualizaractivoList();
                    minimizar({...dato, label: res.name, value: res.name});
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
                Swal.fire({
                    title: errorAxi,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
        }  
    }

    //lee lo que esta en el Select
    const handleChange = (selectedOption) => {
        setOpcionSeleccionada(selectedOption);
    }

    const handlerEliminar = () => {
        const dato = {
            id: data.id,
            codNivel1:nivel2.group.codNivel1,
            name: nivel2.group.name,
            descrp: nivel2.group.descrp 
        }

        Swal.fire({
            title: `Estas seguro que deseas eliminar ${data.name}?`,
            icon: 'warning',
            text: `Se eliminara permanentemente!`,
            showConfirmButton: true,
            showCancelButton: true, // Habilita el botón de cancelar
            confirmButtonText: 'Borrar',
            cancelButtonText:'No, cancelar',
            allowEnterKey: true

        }).then(async (result) => {
            if (result.isConfirmed) {
              // El usuario hizo clic en "Aceptar"
                const id = data.id
                const resp = await eliminarNivel2(id);

                if(resp === "No se puede borrar la nivel2 porque contiene un Nivel3s") {
                    Swal.fire({
                        title: `No puede eliminarse!`,
                        icon: 'warning',
                        text: `Para poder eliminar no tiene que tener ${getValorActualFromDictionary("Nivel3")}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                        
                    })
                    minimizar({...dato, label: dato.name, value:dato.name});
                }else{
                    Swal.fire({
                        title: `Borrado!`,
                        icon: 'success',
                        text: `Eliminado correctamente!`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                    actualizaractivoList();
                    actualizarNivel2List();
                    minimizar(null);
                    handleChangeUbicaciones({},i,'nivel2',{...estructuraNivel1})
                }
            } else if (result.isDismissed) {
             // El usuario hizo clic en "Cancelar" o en cualquier otro lugar fuera del diálogo
                 minimizar({...dato, label: dato.name, value:dato.name});
            }
            });
    }

    return (
        <div className='container-group-form'>
            <div className='title-form-group' style={{backgroundColor: PRINCIPAL, color:NAVBARS}} >
                {titulo} <DictionaryText text={"Nivel2"}/>
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Codigo de <DictionaryText text={"Nivel2"}/>: </div>
                <input disabled={ titulo === "Modificar"} value={nivel2.group.codNivel2} className='label-form-group-data' onChange={data => setNivel2({ ...nivel2, group: {...nivel2.group, codNivel2: data.target.value} })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Nombre: </div>
                <input value={nivel2.group.name} className='label-form-group-data' onChange={data => setNivel2({ ...nivel2, group: {...nivel2.group, name: data.target.value} })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Descripción: </div>
                <textarea className='label-form-group-data' value={nivel2.group.descrp} onChange={data => setNivel2({ ...nivel2, group: {...nivel2.group, descrp: data.target.value} })}/>
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Direccion (opcional): </div>
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                    <input
                        value={nivel2.group.direccion || ''}
                        className='label-form-group-data'
                        style={{ flex: 1 }}
                        placeholder="Ej: Av. Corrientes 1234, CABA"
                        onChange={e => setNivel2({...nivel2, group: {...nivel2.group, direccion: e.target.value, lat: null, lng: null}})}
                    />
                    {nivel2.group.direccion && !nivel2.group.lat && (
                        <button type="button" className="geocodeBtnOPD" onClick={handleGeocodificar}>Validar</button>
                    )}
                    {nivel2.group.lat && <span style={{ color: 'green', fontSize: '0.8rem' }}>&#10003; Validada</span>}
                </div>
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Nivel1: </div>
                <Select
                    styles={{
                        input: (base) => ({
                            ...base,
                            width: "100%",
                            padding: ".4rem",
                            borderRadius: ".5rem",
                            fontSize: "1rem",
                            transition: "border-color .5s"
                        })
                    }}
                    isDisabled={true}
                    placeholder="Elija el nivel1 que corresponda..."
                    options={optionsNivel1}
                    value={areaSeleccionadaNormalizada}
                    onChange={handleChange}
                    
                />
            </div>

            <div className='container-btn-group'>
                <button className='btn-form-group' style={{backgroundColor: COLOR_BOTONES, color:NAVBARS}} onClick={( titulo !== "Modificar") ? handlerGenerar : handlerModificar}>{titulo}</button>
                {
                    (data !== "") &&(
                        <button className='btn-eliminar-form-group' onClick={handlerEliminar}>Eliminar</button>
                    )

                }
                {
                    titulo === "Modificar" ? (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(data)}>Cancelar</button>
                    ) : (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(formDato.activoNivel2)}>Cancelar</button>
                    )
                }
            </div>
        </div>
    );
}

export default FormNivel2;